export const getTaggedUsers = (noteText: string) => {
  const div = document.createElement('div');
  div.innerHTML = noteText;
  const taggedUserElements = div.getElementsByClassName('mention');
  return Array.from(taggedUserElements).map((el: Element) => parseInt((el as any).dataset.id));
};
